<template>
    <v-card
        class="pb-5"
        width="690"
        elevation="0"
        style="border-radius: 10px"
        v-if="this.stepActive == 1"
    >
        <v-card-text>
            <div class="mt-2 mx-1 prompt-title" style="margin-bottom: 14px">
                {{ $t("message.form.topics.documents") }} <strong>*</strong>
            </div>

            <v-row align="center">
                <UploadEvidenceFile
                    ref="document_national_id"
                    v-if="registrationFormDetail.has_document_national_id"
                    :elementKey="document_national_id.name"
                    :student_id="student_id"
                    :evidenceDetail="document_national_id.evidenceDetail"
                    :evidenceCondition="document_national_id.evidenceCondition"
                    :isExtra="false"
                    :studentFullNameTh="studentFullNameTh"
                    :studentFullNameEn="studentFullNameEn"
                    :locale="locale"
                    @loadingUpdate="loadingUpdate"
                    @updateUploadStatus="updateUploadStatus"
                />
                <UploadEvidenceFile
                    ref="document_house_registration"
                    v-if="
                        registrationFormDetail.has_document_house_registration
                    "
                    :elementKey="document_house_registration.name"
                    :student_id="student_id"
                    :evidenceDetail="document_house_registration.evidenceDetail"
                    :evidenceCondition="
                        document_house_registration.evidenceCondition
                    "
                    :isExtra="false"
                    :studentFullNameTh="studentFullNameTh"
                    :studentFullNameEn="studentFullNameEn"
                    :locale="locale"
                    @loadingUpdate="loadingUpdate"
                    @updateUploadStatus="updateUploadStatus"
                />
                <UploadEvidenceFile
                    ref="document_proof_of_birth"
                    v-if="registrationFormDetail.has_document_proof_of_birth"
                    :elementKey="document_proof_of_birth.name"
                    :student_id="student_id"
                    :evidenceDetail="document_proof_of_birth.evidenceDetail"
                    :evidenceCondition="
                        document_proof_of_birth.evidenceCondition
                    "
                    :isExtra="false"
                    :studentFullNameTh="studentFullNameTh"
                    :studentFullNameEn="studentFullNameEn"
                    :locale="locale"
                    @loadingUpdate="loadingUpdate"
                    @updateUploadStatus="updateUploadStatus"
                />
                <UploadEvidenceFile
                    ref="document_proof_of_name_changed"
                    v-if="
                        registrationFormDetail.has_document_proof_of_name_changed
                    "
                    :elementKey="document_proof_of_name_changed.name"
                    :student_id="student_id"
                    :evidenceDetail="
                        document_proof_of_name_changed.evidenceDetail
                    "
                    :evidenceCondition="
                        document_proof_of_name_changed.evidenceCondition
                    "
                    :isExtra="false"
                    :studentFullNameTh="studentFullNameTh"
                    :studentFullNameEn="studentFullNameEn"
                    :locale="locale"
                    @loadingUpdate="loadingUpdate"
                    @updateUploadStatus="updateUploadStatus"
                />
                <UploadEvidenceFile
                    ref="document_proof_of_adopted"
                    v-if="registrationFormDetail.has_document_proof_of_adopted"
                    :elementKey="document_proof_of_adopted.name"
                    :student_id="student_id"
                    :evidenceDetail="document_proof_of_adopted.evidenceDetail"
                    :evidenceCondition="
                        document_proof_of_adopted.evidenceCondition
                    "
                    :isExtra="false"
                    :studentFullNameTh="studentFullNameTh"
                    :studentFullNameEn="studentFullNameEn"
                    :locale="locale"
                    @loadingUpdate="loadingUpdate"
                    @updateUploadStatus="updateUploadStatus"
                />
                <UploadEvidenceFile
                    ref="document_medical_certificate"
                    v-if="
                        registrationFormDetail.has_document_medical_certificate
                    "
                    :elementKey="document_medical_certificate.name"
                    :student_id="student_id"
                    :evidenceDetail="
                        document_medical_certificate.evidenceDetail
                    "
                    :evidenceCondition="
                        document_medical_certificate.evidenceCondition
                    "
                    :isExtra="false"
                    :studentFullNameTh="studentFullNameTh"
                    :studentFullNameEn="studentFullNameEn"
                    :locale="locale"
                    @loadingUpdate="loadingUpdate"
                    @updateUploadStatus="updateUploadStatus"
                />
                <UploadEvidenceFile
                    ref="document_transcript"
                    v-if="registrationFormDetail.has_document_transcript"
                    :elementKey="document_transcript.name"
                    :student_id="student_id"
                    :evidenceDetail="document_transcript.evidenceDetail"
                    :evidenceCondition="document_transcript.evidenceCondition"
                    :isExtra="false"
                    :studentFullNameTh="studentFullNameTh"
                    :studentFullNameEn="studentFullNameEn"
                    :locale="locale"
                    @loadingUpdate="loadingUpdate"
                    @updateUploadStatus="updateUploadStatus"
                />
                <UploadEvidenceFile
                    ref="document_portfolio"
                    v-if="registrationFormDetail.has_document_portfolio"
                    :elementKey="document_portfolio.name"
                    :student_id="student_id"
                    :evidenceDetail="document_portfolio.evidenceDetail"
                    :evidenceCondition="document_portfolio.evidenceCondition"
                    :isExtra="false"
                    :studentFullNameTh="studentFullNameTh"
                    :studentFullNameEn="studentFullNameEn"
                    :locale="locale"
                    @loadingUpdate="loadingUpdate"
                    @updateUploadStatus="updateUploadStatus"
                />
                <!-- Extra documents -->
                <!--eslint-disable-next-line vue/no-use-v-if-with-v-for -->
                <UploadEvidenceFile v-if="extraDocumentsDetail?.length"
                    v-for="document in extraDocumentsDetail"
                    :ref="document.key"
                    :elementKey="document.key"
                    :key="document.key"
                    :student_id="student_id"
                    :evidenceDetail="document.evidenceDetail"
                    :evidenceCondition="document.evidenceCondition"
                    :isExtra="true"
                    :studentFullNameTh="studentFullNameTh"
                    :studentFullNameEn="studentFullNameEn"
                    :locale="locale"
                    @loadingUpdate="loadingUpdate"
                    @updateUploadStatus="updateUploadStatus"
                />

            </v-row>
        </v-card-text>
    </v-card>
</template>

<script>
import UploadEvidenceFile from "@/components/fileElement/UploadEvidenceFile.vue";
import i18n from "@/i18n";

export default {
    name: "StudentEvidence",
    data: () => ({
        document_national_id: {
            name: 'document_national_id',
            evidenceDetail: {
                name: 'copyOfIDCard',
                example: "exam_copyOfIDCard",
            },
            evidenceCondition: {
                preview: "content_copyOfIDCard",
                pattern: "สำเนาบัตรประชาชน",
                pattern_en: 'copy_of_id_card'
            },
        },
        document_house_registration: {
            name: 'document_house_registration',
            evidenceDetail: {
                name: 'copyOfHomeRegistration',
                example: "exam_copyOfHomeRegistration",
            },
            evidenceCondition: {
                preview: "content_copyOfHomeRegistration",
                pattern: "สำเนาทะเบียนบ้าน",
                pattern_en: 'copy_of_home_registration'
            },
        },
        document_proof_of_birth: {
            name: 'document_proof_of_birth',
            evidenceDetail: {
                name: "copyOfBirthCertificate",
                example: "exam_copyOfBirthCertificate",
            },
            evidenceCondition: {
                preview: "content_copyOfBirthCertificate",
                pattern: "สำเนาสูติบัตร",
                pattern_en: 'copy_of_birth_certificate'
            },
        },
        document_proof_of_name_changed: {
            name: 'document_proof_of_name_changed',
            evidenceDetail: {
                name: "copyOfNameChange",
                example: "exam_copyOfNameChange",
            },
            evidenceCondition: {
                preview: "content_copyOfNameChange",
                pattern: "สำเนาการเปลี่ยนชื่อ",
                pattern_en: 'copy_of_certificate_of_first_name_change'
            },
        },
        document_proof_of_adopted: {
            name: 'document_proof_of_adopted',
            evidenceDetail: {
                name: "copyOfLegitimationOfChild",
                example: "exam_copyOfLegitimationOfChild",
            },
            evidenceCondition: {
                preview: "content_copyOfLegitimationOfChild",
                pattern: "สำเนาทะเบียนบุตรบุญธรรม",
                pattern_en: 'copy_of_legitimation_of_child'
            },
        },
        document_medical_certificate: {
            name: 'document_medical_certificate',
            evidenceDetail: {
                name: "medicalCertificate",
                example: "exam_medicalCertificate",
            },
            evidenceCondition: {
                preview: "content_medicalCertificate",
                pattern: "ใบรับรองแพทย์",
                pattern_en: 'medical_certificate'
            },
        },
        document_transcript: {
            name: 'document_transcript',
            evidenceDetail: {
                name: "copyOfTranscript",
                example: "exam_CopyOfTranscript",
            },
            evidenceCondition: {
                preview: "content_CopyOfTranscript",
                pattern: "สำเนาปพ1",
                pattern_en: 'copy_of_transcript'
            },
        },
        document_portfolio: {
            name: 'document_portfolio',
            evidenceDetail: {
                name: "portfolio",
                example: "exam_portfolio",
            },
            evidenceCondition: {
                preview: "content_portfolio",
                pattern: "แฟ้มสะสมผลงาน",
                pattern_en: 'portfolio'
            },
        },
        uploadStatus: {},
        isUploadComplete: false,
        isUploadToServer: false,
        isUploading: false,
    }),
    props: {
        stepActive: Number,
        registrationFormDetail: Object,
        extraDocuments: Array,
        student_id: Number,
        isExtra: Boolean,
        studentFullNameTh: String,
        studentFullNameEn: String
    },
    computed: {
        extraDocumentsDetail() {
            if (this.extraDocuments?.length) {
                const extraDocuments = [];
                for (let i = 0; i < this.extraDocuments.length; i++) {
                    if (this.exceptDoc(this.extraDocuments[i].document_name)) continue

                    const detail = {
                        name: this.extraDocuments[i].document_name,
                        evidenceDetail: {
                            name: this.extraDocuments[i].document_name,
                            example: `${this.extraDocuments[i].document_name}_`+ i18n.t("message.doc.exam_name"),
                        },
                        evidenceCondition: {
                            preview: `${this.extraDocuments[i].document_name}_`+ i18n.t("message.doc.content_name"),
                            pattern: this.extraDocuments[i].document_name,
                            pattern_en: this.extraDocuments[i].document_name,
                        },
                        key: `extra_${i}`
                    };
                    extraDocuments.push(detail);
                }
                return extraDocuments;
            }
            return null;
        },
        locale() {
            return i18n.locale;
        },
    },
    methods: {
        async uploadToServer(){
            try{
                this.loadingUpdate(1)
                if(this.isUploadComplete && !this.isUploading){
                    this.isUploading = true
                    let fileKeys = Object.keys(this.uploadStatus)
                    let startUploadTime = new Date()
                    for(let key of fileKeys) {
                        let uploadFileTime = new Date()
                        if(Array.isArray(this.$refs?.[key])){
                            await this.$refs?.[key][0]?.confirmUploadFile() // Upload
                        }
                        else{
                            await this.$refs?.[key]?.confirmUploadFile() // Upload
                        }
                        uploadFileTime = new Date() - uploadFileTime
                        console.log(`Upload ${key} file: ${uploadFileTime / 1000} sec`);
                    }
                    startUploadTime = new Date() - startUploadTime
                    console.log("Upload files: " + startUploadTime / 1000 + " sec");
                    this.isUploadToServer = true
                }
            }
            catch(e){
                this.isUploadToServer = false
                throw new e
            }
            finally{
                this.isUploading = false
                this.loadingUpdate(-1)
            }
            return this.isUploadToServer
        },
        loadingUpdate(value) {
            this.$emit("loadingUpdate", value);
        },
        updateUploadStatus(target, value){
            if(this.uploadStatus[target] != undefined){
                this.uploadStatus[target] = value;
            }
            let result = true
            Object.keys(this.uploadStatus).forEach((key) => {
                result = result && this.uploadStatus?.[key];
            })
            this.isUploadComplete = result
        },
        prepareUploadStatus(){
            if(this.registrationFormDetail){
                const has_document_keys = [
                    "document_national_id",
                    "document_house_registration",
                    "document_proof_of_birth",
                    "document_proof_of_name_changed",
                    "document_proof_of_adopted",
                    "document_medical_certificate",
                    "document_transcript",
                    "document_portfolio",
                ]
                has_document_keys.forEach((key) => {
                    if(Object.hasOwn(this.registrationFormDetail, `has_${key}`)){
                        if(this.registrationFormDetail[`has_${key}`] == true){
                            this.uploadStatus[key] = false
                        }
                    }
                });
            }
            if(this.extraDocuments?.length){
                for(let i = 0 ; i < this.extraDocuments.length ; i++){
                    if (this.exceptDoc(this.extraDocuments[i].document_name)) continue

                    this.uploadStatus[`extra_${i}`] = false
                }
            }
            if(Object.keys(this.uploadStatus).length > 0)
                this.isUploadComplete = false
            else
                this.isUploadComplete = true
        },

        exceptDoc(document_name) {
            return ([this.$t('message.doc.extraDoc1'), this.$t('message.doc.extraDoc5')].includes(document_name))
        }
    },
    created(){
        this.prepareUploadStatus()
    },
    components: { UploadEvidenceFile },
};
</script>

<style lang="scss" scoped>
li {
    list-style: none;
}
li:before {
    content: "·";
    font-size: 30px;
    vertical-align: -3px;
    line-height: 23px;
}
</style>

<style scoped>
.form-label{
    font-size: 18px;
}
</style>
